/**
 * Boot every domain whose `index.ts` lives under `src/domains/<id>/`.
 * Vite resolves the glob at build time; new domains appear by adding
 * a folder, no engine edit needed.
 */
const domainModules = import.meta.glob("../../domains/*/index.ts");
export async function bootDomains(registry) {
    const ids = [];
    for (const path of Object.keys(domainModules).sort()) {
        const mod = await domainModules[path]();
        if (typeof mod.register !== "function") {
            console.warn(`[loader] ${path} has no register() export; skipped`);
            continue;
        }
        await mod.register(registry);
        const segments = path.split("/");
        ids.push(segments[segments.length - 2] ?? path);
    }
    return ids;
}
